<template>
  <div />
</template>

<script>
export default {
  name: 'AppRedirect',
  mounted() {
    const ua = navigator.userAgent || '';

    const isAndroid = /Android/i.test(ua);
    const isIPhone = /iPhone|iPod/.test(ua);

    let url = ''

    if (isIPhone) {
      url = 'itms-apps://itunes.apple.com/app/id6744648027';
    } else if (isAndroid) {
      url = 'https://play.google.com/store/apps/details?id=com.haxo.haxosetup';
    } else {
      url = 'https://haxo.cloud';
    }

    window.location.replace(url)
  }
}
</script>